// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var Random = require("bs-platform/lib/js/random.js");
var $$String = require("bs-platform/lib/js/string.js");
var Belt_Id = require("bs-platform/lib/js/belt_Id.js");
var Belt_Set = require("bs-platform/lib/js/belt_Set.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Word$Phonics = require("./Word.bs.js");
var Caml_primitive = require("bs-platform/lib/js/caml_primitive.js");

var storageKey = "phonemes";

function fromString(words) {
  return List.map(Word$Phonics.fromString, List.filter((function (s) {
                      return s !== "";
                    }))($$String.split_on_char(/* "|" */124, words)));
}

function toString(words) {
  return List.fold_left((function (acc, word) {
                return acc + ((
                          acc === "" ? "" : "|"
                        ) + Word$Phonics.toString(word));
              }), "", words);
}

function cmp(a, b) {
  return Caml_primitive.caml_string_compare(Word$Phonics.toString(a), Word$Phonics.toString(b));
}

var WordCompare = Belt_Id.MakeComparable({
      cmp: cmp
    });

function addWord(existingWords, word) {
  var __x = Belt_Option.mapWithDefault(existingWords, /* [] */0, fromString);
  var existingWordSet = List.fold_left(Belt_Set.add, Belt_Set.make(WordCompare), __x);
  var updatedWordSet = Belt_Set.add(existingWordSet, word);
  return toString(Belt_Set.toList(updatedWordSet));
}

function saveWord(word) {
  var existingWords = localStorage.getItem(storageKey);
  var updatedWords = addWord(existingWords === null ? undefined : Caml_option.some(existingWords), word);
  localStorage.setItem(storageKey, updatedWords);
  return /* () */0;
}

function removeWord(existingWords, word) {
  var __x = Belt_Option.mapWithDefault(existingWords, /* [] */0, fromString);
  var existingWordSet = List.fold_left(Belt_Set.add, Belt_Set.make(WordCompare), __x);
  var updatedWordSet = Belt_Set.remove(existingWordSet, word);
  return toString(Belt_Set.toList(updatedWordSet));
}

function loadWords(param) {
  var __x = localStorage.getItem(storageKey);
  return Belt_Option.mapWithDefault(__x === null ? undefined : Caml_option.some(__x), /* [] */0, fromString);
}

function deleteWord(word) {
  var existingWords = localStorage.getItem(storageKey);
  var updatedWords = removeWord(existingWords === null ? undefined : Caml_option.some(existingWords), word);
  localStorage.setItem(storageKey, updatedWords);
  return loadWords(/* () */0);
}

function prevWord(word) {
  return Belt_Option.getWithDefault(Word$Phonics.findPrev(loadWords(/* () */0), word), word);
}

function nextWord(word) {
  return Belt_Option.getWithDefault(Word$Phonics.findNext(loadWords(/* () */0), word), word);
}

function shuffleWord(param) {
  var words = loadWords(/* () */0);
  var randomIndex = Random.$$int(List.length(words));
  return List.nth_opt(words, randomIndex);
}

exports.storageKey = storageKey;
exports.fromString = fromString;
exports.toString = toString;
exports.WordCompare = WordCompare;
exports.addWord = addWord;
exports.saveWord = saveWord;
exports.removeWord = removeWord;
exports.loadWords = loadWords;
exports.deleteWord = deleteWord;
exports.prevWord = prevWord;
exports.nextWord = nextWord;
exports.shuffleWord = shuffleWord;
/* WordCompare Not a pure module */
